<template>
  <div class="home">
    <Header></Header>
    <router-view></router-view>
    <Footer ></Footer>
  </div>
</template>
<script lang="ts" setup>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { ref, onMounted, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
const route = useRoute()
const showFooter = ref(true)
onMounted(() => {
  if (route.name === 'contact') {
    showFooter.value = false
  } else {
    showFooter.value = true
  }
})
watchEffect(() => {
  if (route.name === 'contact') {
    showFooter.value = false
  } else {
    showFooter.value = true
  }
})
</script>
